// extracted by mini-css-extract-plugin
export default {"link":"light_link__v5NCb","linkImg":"light_linkImg__432uq color_colorLightBackground__vzlHN","linkOverflov":"light_linkOverflov__Ue0Sz undefined"};